import React, { useState, useEffect } from "react";
import { useRouter } from "next/router";
import Link from "next/link";
import Image from "next/image";
import NavigationLogo from '../../public/images/logo.svg'
import { useTranslations } from '../../locales/useTranslations';
import { allLangs } from '../../locales/config-lang';
import { BiChevronDown, BiChevronRight } from "react-icons/bi";

const Navbar = () => {
    const [currentPath, setCurrentPath] = useState("");
    const router = useRouter();
    const { t, locale, changeLanguage, locales } = useTranslations();

    useEffect(() => {
        setCurrentPath(router.asPath);
    }, [router]);

    const [menu, setMenu] = React.useState(true);
    const [languageDropdown, setLanguageDropdown] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const languageRef = React.useRef(null);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 992);
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (languageRef.current && !languageRef.current.contains(event.target)) {
                setLanguageDropdown(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const toggleMenu = () => {
        setMenu(!menu);
    };

    const toggleNavbar = () => {
        setMenu(!menu);
    };

    const handleLanguageChange = (newLocale) => {
        changeLanguage(newLocale);
        setLanguageDropdown(false);
    };

    // CSS-Klassen für das mobile Menü
    const classOne = menu ? 'collapse navbar-collapse' : 'collapse navbar-collapse show';
    const classTwo = menu ? 'navbar-toggler navbar-toggler-right collapsed' : 'navbar-toggler navbar-toggler-right';

    const currentLanguage = locale;

    return (
        <>
            <div id="navbar" className="navbar-area navbar-style-two is-sticky">
                <div className="main-nav">
                    <div className="container">
                        <nav className="navbar navbar-expand-md navbar-light">
                            <Link href="/" className="navbar-brand">
                                <Image
                                    priority
                                    width={230}
                                    height={58}
                                    src={NavigationLogo}
                                    alt="Simplify Data Logo"
                                />
                            </Link>

                            <button
                                onClick={toggleNavbar}
                                className={classTwo}
                                type="button"
                                data-toggle="collapse"
                                data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                                aria-expanded="false"
                                aria-label="Switch Navigation"
                            >
                                <span className="icon-bar top-bar"></span>
                                <span className="icon-bar middle-bar"></span>
                                <span className="icon-bar bottom-bar"></span>
                            </button>

                            <div className={classOne} id="navbarSupportedContent">
                                <ul className="navbar-nav">
                                    <li className="nav-item">
                                        <Link
                                            href="/dienstleistungen"
                                            className="nav-link"
                                        >
                                            {t('services')} <BiChevronDown />
                                        </Link>

                                        <ul className="dropdown-menu">
                                            <li className="nav-item">
                                                <Link
                                                    href="/app-development"
                                                    className={`nav-link ${currentPath == "/app-development/" && "active"}`}
                                                >
                                                    {t('navAppDevelopment')}
                                                </Link>
                                            </li>

                                            <li className="nav-item">
                                                <Link
                                                    href="/web-development"
                                                    className={`nav-link ${currentPath == "/web-development/" && "active"}`}
                                                >
                                                    {t('navWebDevelopment')}
                                                    <BiChevronRight className="float-right" />
                                                </Link>

                                                <ul className="dropdown-menu">
                                                    <li className="nav-item">
                                                        <Link
                                                            href="/web-development/wordpress-entwicklung"
                                                            className={`nav-link ${currentPath == "/web-development/wordpress-entwicklung" && "active"
                                                                }`}
                                                        >
                                                            {t('navWordpressDevelopment')}
                                                        </Link>
                                                    </li>

                                                    <li className="nav-item">
                                                        <Link
                                                            href="/web-development/wordpress-betreuung"
                                                            className={`nav-link ${currentPath == "/web-development/wordpress-betreuung" && "active"
                                                                }`}
                                                        >
                                                            {t('navWordpressSupport')}
                                                        </Link>
                                                    </li>
                                                </ul>
                                            </li>

                                            <li className="nav-item">
                                                <Link href="/software-development" className={`nav-link ${currentPath == "/software-development/" && "active"}`}>
                                                    {t('navSoftwareDevelopment')}
                                                </Link>
                                            </li>

                                            <li className="nav-item">
                                                <Link href="/it-consulting" className={`nav-link ${currentPath == "/it-consulting/" && "active"}`}>
                                                    {t('navItConsulting')}
                                                </Link>
                                            </li>

                                            <li className="nav-item">
                                                <Link href="/business-analytics" className={`nav-link ${currentPath == "/business-analytics/" && "active"}`}>
                                                    {t('navBusinessAnalytics')}
                                                    <BiChevronRight className="float-right" />
                                                </Link>
                                                <ul className="dropdown-menu">
                                                    <li className="nav-item">
                                                        <Link
                                                            href="/business-analytics/power-bi"
                                                            className={`nav-link ${currentPath == "/business-analytics/power-bi" && "active"
                                                                }`}
                                                        >
                                                            {t('navPowerBI')}
                                                        </Link>
                                                    </li>

                                                    <li className="nav-item">
                                                        <Link
                                                            href="/business-analytics/metabase"
                                                            className={`nav-link ${currentPath == "/business-analytics/metabase" && "active"
                                                                }`}
                                                        >
                                                            {t('navMetabase')}
                                                        </Link>
                                                    </li>
                                                </ul>
                                            </li>

                                            <li className="nav-item">
                                                <Link href="/kuenstliche-intelligenz" className={`nav-link ${currentPath == "/kuenstliche-intelligenz/" && "active"}`}>
                                                    {t('navArtificialIntelligence')}
                                                </Link>
                                            </li>
                                        </ul>
                                    </li>

                                    {/*<li className="nav-item">
                                        <Link href="/partner" className={`nav-link ${currentPath == "/partner/" && "active"}`}>
                                            {t('partner')}
                                        </Link>
                                    </li>*/}

                                    <li className="nav-item">
                                        <Link
                                            href="/managed-services"
                                            className={`nav-link ${
                                                currentPath.startsWith('/managed-services') ? 'active' : ''
                                            }`}
                                        >
                                            {t('navManagedServices')} <BiChevronDown />
                                        </Link>

                                        <ul className="dropdown-menu">
                                            <li className="nav-item">
                                                <Link
                                                    href="/managed-services/zerotrustvpn"
                                                    className={`nav-link ${
                                                        currentPath.startsWith('/managed-services/zerotrustvpn') ? 'active' : ''
                                                    }`}
                                                >
                                                    {t('navManagedServicesZeroTrustVpn')}
                                                </Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link
                                                    href="/managed-services/business-mail"
                                                    className={`nav-link ${
                                                        currentPath.startsWith('/managed-services/business-mail') ? 'active' : ''
                                                    }`}
                                                >
                                                    {t('navManagedServicesMailServer')}
                                                </Link>
                                            </li>
                                        </ul>
                                    </li>

                                    <li className="nav-item">
                                        <Link
                                            href="/woocommerce-schnittstelle"
                                            className="nav-link"
                                            onClick={(e) => e.preventDefault()}
                                        >
                                            {t('navProducts')} <BiChevronDown />
                                        </Link>

                                        <ul className="dropdown-menu">
                                            <li className="nav-item">
                                                <Link
                                                    href="/qr-flow"
                                                    className={`nav-link ${currentPath == "/qr-flow/" && "active"}`}
                                                >
                                                    {t('navQrFlow')}
                                                </Link>
                                            </li>

                                            <li className="nav-item">
                                                <Link
                                                    href="/woocommerce-schnittstelle"
                                                    className={`nav-link ${currentPath == "/woocommerce-schnittstelle" && "active"}`}
                                                >
                                                    {t('navWooCommerceSchnittstelle')}
                                                </Link>
                                            </li>

                                            <li className="nav-item">
                                                <Link
                                                    href="/opensource"
                                                    className={`nav-link ${currentPath == "/opensource" && "active"}`}
                                                >
                                                    {t('navOpenSource')}
                                                </Link>
                                            </li>
                                        </ul>
                                    </li>

                                    <li className="nav-item">
                                        <Link
                                            href="/about"
                                            className={`nav-link ${currentPath == "/about/" || currentPath == "/karriere/" ? "active" : ""}`}
                                        >
                                            {t('aboutus')} <BiChevronDown />
                                        </Link>

                                        <ul className="dropdown-menu">
                                            <li className="nav-item">
                                                <Link
                                                    href="/karriere"
                                                    className={`nav-link ${currentPath == "/karriere/" && "active"}`}
                                                >
                                                    {t('navCareer')}
                                                </Link>
                                            </li>
                                        </ul>
                                    </li>

                                    <li className="nav-item">
                                        <Link href="/blog" className={`nav-link ${currentPath == "/blog" || currentPath.startsWith("/blog/") ? "active" : ""}`}>
                                            {t('navBlog')}
                                        </Link>
                                    </li>

                                    <li className="nav-item">
                                        <Link href="/kontakt" className={`nav-link ${currentPath == "/kontakt/" && "active"}`}>
                                            {t('navContact')}
                                        </Link>
                                    </li>
                                </ul>

                                {/* Desktop Language Selector */}
                                {!isMobile && (
                                    <div className="language-selector desktop-language" ref={languageRef}>
                                        <button
                                            type="button"
                                            className={`language-dropdown ${languageDropdown ? 'is-open' : ''}`}
                                            onClick={() => setLanguageDropdown((open) => !open)}
                                            aria-expanded={languageDropdown}
                                            aria-haspopup="listbox"
                                            aria-label={t('selectLanguage')}
                                        >
                                            <span className="language-flag" aria-hidden="true">
                                                {currentLanguage === 'de' ? '🇩🇪' : '🇬🇧'}
                                            </span>
                                            <span className="language-text">
                                                {currentLanguage === 'de' ? 'Deutsch' : 'English'}
                                            </span>
                                            <BiChevronDown className="language-chevron" aria-hidden="true" />
                                        </button>

                                        <ul
                                            className={`language-menu ${languageDropdown ? 'show' : ''}`}
                                            role="listbox"
                                        >
                                            {allLangs.map((lang) => (
                                                <li key={lang.value}>
                                                    <button
                                                        type="button"
                                                        className={`language-option ${currentLanguage === lang.value ? 'active' : ''}`}
                                                        onClick={() => handleLanguageChange(lang.value)}
                                                        role="option"
                                                        aria-selected={currentLanguage === lang.value}
                                                    >
                                                        <span className="language-flag" aria-hidden="true">
                                                            {lang.value === 'de' ? '🇩🇪' : '🇬🇧'}
                                                        </span>
                                                        <span className="language-text">
                                                            {lang.value === 'de' ? 'Deutsch' : 'English'}
                                                        </span>
                                                    </button>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                )}

                                {/* Mobile Language Selector */}
                                {isMobile && (
                                    <div className="mobile-language-selector">
                                        <div className="mobile-language-title">{t('selectLanguage')}</div>
                                        <div className="mobile-language-buttons">
                                            {allLangs.map((lang) => (
                                                <button
                                                    key={lang.value}
                                                    type="button"
                                                    className={`mobile-language-btn ${currentLanguage === lang.value ? 'active' : ''}`}
                                                    onClick={() => {
                                                        handleLanguageChange(lang.value);
                                                        setMenu(true);
                                                    }}
                                                >
                                                    <span className="language-flag" aria-hidden="true">
                                                        {lang.value === 'de' ? '🇩🇪' : '🇬🇧'}
                                                    </span>
                                                    <span className="language-text">
                                                        {lang.value === 'de' ? 'Deutsch' : 'English'}
                                                    </span>
                                                </button>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </nav>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Navbar;